<template>
  <div class="home">
    <div class="">
      <banner jsClass="join2" :picS="slide_item" :navigation="false"></banner>
    </div>
    <div v-if="indexData.company_video" class="video widthBox">
      <video controls :src="indexData.company_video.video"></video>
    </div>

    <div class="widthBox">
      <div class="join">
        <titleOne titleurl="/about" title="ABOUT EBERS"></titleOne>
        <div class="picBox">
          <!-- <banner itemType="join" jsClass="join" :picS="indexData.join_politely" :navigation="false"></banner> -->
          <img style="width: 100%;" :src="indexData.ebers_info.img" alt="">
        </div>
      </div>
    </div>

    <div class="product">
      <titleOne titleurl="/product" title="PRODUCTS"></titleOne>
      <div class="rotation widthBox ">
        <banner jsClass="indpro" @rotationIndex="getRotation" itemType="indpro" :picS="indexData.product_center"
          :navigation="false"></banner>
      </div>
    </div>

    <!-- <div class="raw ">
      <titleOne
        class="hidden-xs-only"
        id="index_4"
        titleurl="/raw"
        title="QUALITY RAW MATERIALS"
      ></titleOne>
      <div class="rawList ">
        <ul class="widthBox acea-row">
          <li v-for="(item, index) in indexData.case_sharing" :key="index">
            <router-link :to="'/raw_detail?id=' + item.id">
              <img :src="item.back_img" alt="" class="pic" />
              <h4>{{ item.title }}</h4>
              <div class="txt">
                <p>{{ item.describe }}</p>
              </div>
              <div class="txt2">
                <span>READ MORE</span>
                
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <router-link class="moreBtn" style="display: block" :to="'/raw'">
        READ MORE
      </router-link>
    </div> -->
    <div class="news">
      <titleOne  id="index_4" titleurl="/news" title="NEWS&MEDIA"></titleOne>
      <div class="newsBox widthBox acea-row row-between-wrapper">
        <div class="item" v-for="(item, index) in indexData.news_information" :key="index">
          <img :src="item.img" alt="" />
          <div class="info">
            <div class="name">{{ item.title }}</div>
            <p>{{ item.describe }}</p>
            <router-link class="more" :to="'/news_detail?id=' + item.id">
              MORE
            </router-link>
          </div>
        </div>
      </div>
      <router-link class="moreBtn" style="display: block" :to="'/news'">
        READ MORE
      </router-link>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner.vue";
import bannerA from "@/components/bannerA.vue";
import titleOne from "@/components/titleOne.vue";
export default {
  name: "index",
  components: {
    banner,
    bannerA,
    titleOne,
  },
  computed: {
    bannerS() {
      return this.$store.state.bannerS;
    },
  },
  data() {
    return {
      proTab: ["南瓜籽秋葵精华粉", "私密理疗仪", "男士保湿凝胶", "男士润养膏"],
      proTabIndex: 0,
      indexData: {},
      brandIndex: 0,
      proIndex: 0,
      mobile: false,
      slide_item: []
    };
  },
  created() {
    var width = document.body.clientWidth;
    if (width <= 768) {
      this.mobile = true;
    }
  },
  mounted() {
    this.$api.get("home/index/webIndex", {}).then((res) => {
      this.$set(this, "indexData", res.data);
      this.slide_item = res.data.slide_item;
      console.log("home/index/webIndex--------------------", res.data);
    });
    var to = this.$route.query.to;
    if (to) {
      this.$el.querySelector(to);
    }
  },
  methods: {
    getRotation(e) {
      console.log(e);
      this.proTabIndex = e;
    },
    proTabChange(e) {
      this.proTabIndex = e;
      console.log(this.proTabIndex);
    },
    proChange(e) {
      console.log(e);
      this.proIndex = e.currentTarget.dataset.index;
    },
    brandChange(e) {
      var type = e.currentTarget.dataset.type;
      var brandIndex = this.brandIndex;
      if (type == "a") {
        console.log(1);
        if (brandIndex > 0) {
          brandIndex--;
        }
      } else if (type == "b") {
        console.log(2);
        if (brandIndex < this.indexData.brand_introduction.length - 1) {
          brandIndex++;
        }
      }
      this.brandIndex = brandIndex;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
$paddingTop: 60px;
$marginTop: 50px;

.video {
  height: auto;
  margin: auto;
  margin-top: 70px;
  video {
    width: 100%;
    height: auto;
  }
}

.join {
  padding-top: $paddingTop;

  .picBox {
    margin-top: $marginTop;
  }
}

.case {
  padding-top: $paddingTop;

  .picBox {
    margin-top: $marginTop;
    overflow: hidden;
  }
}

.separate {
  padding-top: $paddingTop;

  &.rotateY {
    transform: rotateY(180deg);
  }

  img {
    width: 100%;
  }
}

.product {
  padding-top: $paddingTop;

  .productBox {
    margin-top: $marginTop;

    .proTitle {
      .item {
        cursor: pointer;
        opacity: 0.5;
        margin: 0 0px;
        height: 140px;

        img {
          width: 62px;
          display: none;
        }

        &.active {
          opacity: 1;
          border-bottom: 2px solid #1d2a55;

          img {
            display: block;
          }
        }

        .txt {
          margin-left: 36px;
          color: #1d2a55;

          .name {
            font-size: 36px;
          }

          .en {
            font-size: 18px;
          }
        }
      }
    }
  }

  .picBox {
    img {
      width: 100%;
    }
  }

  .rotation {
    margin-top: 50px;
    border-radius: 20px;
    overflow: hidden;
    position: relative;

    .tabs {
      background: #1d2a55;
      border-radius: 36px;
      background-size: 100% 100%;
      height: 72px;
      position: absolute;
      left: 50%;
      top: 36px;
      padding: 0 0px;
      transform: translate(-50%, 0);
      z-index: 2;
      display: flex;

      .item {
        max-width: 50%;
        text-align: center;
        color: #fff;
        height: 72px;
        line-height: 52px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        box-sizing: border-box;
        padding: 10px 5px;
        text-overflow: ellipsis;

        span {
          font-size: 22px;
          display: block;
          padding: 0 6px;
        }

        &.active {
          color: #1d2a55;

          span {
            font-size: 22px;
            background: #fff;
            border-radius: 36px;
            box-shadow: 0px -3px 0 0 rgba($color: #000000, $alpha: 0.1) inset;
          }
        }
      }
    }
  }
}

.raw {
  padding-top: 50px;

  .rawList {
    padding: 80px 0 0;

    li {
      width: calc(100% / 3 - 30px);
      background: #fff;
      box-shadow: 0px 5px 19px 1px rgba(29, 42, 85, 0.2);
      margin-right: 45px;
      padding-bottom: 30px;
      margin-bottom: 50px;
      text-align: center;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .pic {
        width: 100%;
      }

      h4 {
        font-size: 32px;
        padding: 30px 0;
        margin: 0 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #777;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 80px;
          height: 4px;
          background: #777;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      .txt {
        margin-top: 30px;
        padding: 0 30px;

        p {
          color: rgba($color: #777, $alpha: 0.5);
          font-size: 24px;
        }
      }

      .txt2 {
        display: none;
        text-align: left;
        font-size: 12px;
        color: #777;
        margin: 0 14px;
        margin-top: 12px;

      }

      &:hover {
        h4 {
          color: #e11111;

          &::after {
            background: #e11111;
          }
        }

        .txt p {
          color: #e11111;
        }
      }
    }
  }

  .moreBtn {
    color: #fff;
    font-size: 20px;
    width: 170px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #777;
    margin: 0 auto;

    &:hover {
      background: #e11111;
    }
  }
}

.news {
  padding-top: $paddingTop;

  .newsBox {
    margin-top: $marginTop;

    .item {
      flex: 1;
      background: rgba($color: #1d2a55, $alpha: 0.05);
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }

      img {
        width: 100%;
      }

      &:hover .info {
        color: #e11111;

        .more {
          background: #e11111;
        }
      }

      .info {
        padding: 20px 20px;
        color: #777;

        .name {
          font-size: 24px;
          line-height: 36px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        p {
          margin-top: 10px;
          font-size: 18px;
          line-height: 24px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .more {
          color: #fff;
          font-size: 12px;
          width: 130px;
          height: 30px;
          display: block;
          line-height: 30px;
          text-align: center;
          background: #777;
          margin-top: 20px;
        }
      }
    }
  }

  .moreBtn {
    color: #fff;
    font-size: 20px;
    width: 170px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #777;
    margin: 40px auto 0 auto;

    &:hover {
      background: #e11111;
    }
  }
}

@media screen and(max-width:768px) {
  .video{
    
  margin-top: 32px;
  }
  .join {
    padding-top: 15px;

    .picBox {
      margin-top: 14px;
    }
  }

  .case {
    padding-top: 15px;

    .picBox {
      margin-top: 14px;
    }
  }

  .raw {
    padding: 20px;

    .moreBtn {
      margin-top: 20px;
      font-size: 12px;

    }

    .rawList {
      padding-top: 0px;

      .widthBox {
        padding: 0;

        li {
          width: 100%;
          margin: 0;
          margin-top: 20px;

          h4 {
            text-align: left;
            font-size: 16px;
            color: #4D4D4D;
            padding: 16px 0;
            margin: 0 12px;
          }

          .txt {
            margin: 0;
            padding: 0 12px;
          }

          .txt2 {
            display: block;

            span {
              border-bottom: 1px solid #777;
            }
          }

          a {
            margin: 0 !important;
          }

          h4::after {
            display: none;
          }

          p {
            text-align: left;
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }
  }

  .separate {
    padding-top: 20px;
  }

  .product {
    padding-top: 15px;

    .productBox {
      margin-top: 14px;

      .proTitle .item {
        margin: 0;
        height: auto;
        padding: 10px 0;

        img {
          width: 21px;
        }

        .txt {
          margin-left: 10px;

          .name {
            font-size: 16px;
            line-height: 32px;
          }

          .en {
            font-size: 10px;
          }
        }
      }
    }

    .rotation {
      margin-top: 14px;

      .tabs {
        display: none;
      }
    }
  }

  .about {
    padding-top: 15px;

    .aboutBox {
      margin-top: 20px;

      .aboutCont {
        padding: 20px;
      }

      .aboutR {
        padding: 30px 10px 10px;

        h4 {
          font-size: 16px;
          line-height: 24px;
        }

        p {
          margin-top: 10px;
          font-size: 12px;
          line-height: 20px;
          max-height: 110px;
        }

        .more {
          margin-top: 10px;
          font-size: 16px;
          width: auto;
          border: 0;
          height: 24px;
          line-height: 24px;
          margin-right: 10px;
          text-align: left;
          box-sizing: border-box;
        }

        .mobileBtn {
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 18px;
          margin: 10px 4px 0;
          text-align: center;
          font-weight: bold;
          color: #333;
          background: rgba(0, 0, 0, 0.2);
        }
      }

      .aboutDetail .about_btn.prev {
        left: -20px;
      }

      .aboutDetail .about_btn.next {
        right: -20px;
      }
    }
  }

  .news {
    padding-top: 15px;

    .newsBox {
      margin-top: 20px;

      .item {
        flex: inherit;
        margin-left: 0;
        margin-bottom: 10px;
        width: 100%;

        .info {
          padding: 10px;

          .name {
            font-size: 16px;
            line-height: 24px;
          }

          p {
            font-size: 12px;
            line-height: 20px;
          }

          .more {
            // display: none;
            background: none;
            box-sizing: border-box;
            color: #4D4D4D;
            font-size: 12px;
            border-bottom: 1px solid #4D4D4D;
            width: auto;
            display: inline-block;
            height: auto;
            line-height: 14px;
          }
        }
      }
    }

    .moreBtn {
      margin-top: 20px;
      font-size: 16px;
      background: #333333;
    }
  }
}</style>
